import { TestImage } from "@assets/constant/index.constant";
import { endpoint } from "@services/api.services";
import { GeneralCard, TableCard } from "@ui/internal/components/card";
import { formatNumber } from "@utils/helper/index.helper";
import { usePathname } from "@utils/hook/index.hook";
import { QueryMetaData } from "@utils/interface/index.interface";
import { JourneyData } from "@utils/interface/journey.interface";
import { useListData } from "@utils/query/index.query";
import { useMetaStore } from "@utils/states/index.state";
import { format } from "date-fns";
import React, { useEffect } from "react";
import { useSearchParams } from "react-router";
import { ColumnList } from "./column/index.column";
import JourneyForm from "./form/journey.form";

type Props = {};
interface SelectionProps {
  clarity: number;
  learning: number;
  mentor: number;
  achieve: number;
}
const index: React.FC<Props> = ({}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { search, date } = useMetaStore();
  const pathname = usePathname();
  /* ================================================= api calls logic ================================================= */
  const { data, isPending, refetch, error } = useListData<
    QueryMetaData<JourneyData, SelectionProps>
  >({
    params: {
      page: searchParams.get("tpage") || 1,
      size: searchParams.get("per") || 10,
      search,
      created_date__gte: date.from ? format(date.from, "yyyy-MM-dd") : "",
      created_date__lte: date.to ? format(date.to, "yyyy-MM-dd") : "",
      ordering: searchParams.get("ordering") || "order",
      section:
        searchParams
          .get("data-category")
          ?.toLocaleLowerCase()
          ?.split("-")[0] === "all"
          ? ""
          : searchParams
              .get("data-category")
              ?.toLocaleLowerCase()
              ?.split("-")[0] || "",
    },
    endpoint: endpoint["journey"],
    key: `${pathname}-listing`,
    window: true,
  });
  // rollback
  useEffect(() => {
    if (error?.status === 404 && error?.data?.detail === "Invalid page.") {
      searchParams.set("tpage", "1");
      setSearchParams(searchParams);
    }
  }, [error]);

  const groupRefetch = () => {
    refetch();
  };

  const columns = ColumnList({ refetch: groupRefetch });
  return (<>
      <TableCard
        bulkActions
        table_content={{
          mode: "default",
          type: pathname,
        }}
        orientationPosition="down"
        tableHeaderData={[
          {
            id: 1,
            name: "All",
            count: formatNumber(data?.data?.total_count as number) || 0,
          },
          {
            id: 2,
            name: "Clarity",
            count: formatNumber(data?.data?.sections?.clarity || 0),
          },
          {
            id: 3,
            name: "Learning",
            count: formatNumber(data?.data?.sections?.learning || 0),
          },
          {
            id: 4,
            name: "Mentor",
            count: formatNumber(data?.data?.sections?.mentor || 0),
          },
          {
            id: 5,
            name: "Achieve",
            count: formatNumber(data?.data?.sections?.achieve || 0),
          },
        ]}
        endpoint={endpoint["journey"]}
        inject_ui_table_actions={<></>}
        grid={
          <GeneralCard
            showCheck
            type="journey"
            content={{
              image: TestImage,
              title: "Focused Mode",
              tags: ["Clarity"],
            }}
            onDelete={() => {}}
            onEdit={() => {}}
          />
        }
        columns={columns}
        refetch={groupRefetch}
        isPending={isPending}
        rows={data?.data?.results ?? []}
        sortableFilter={{
          search: search,
          ordering: searchParams.get("ordering") || "order",
          section:
            searchParams
              .get("data-category")
              ?.toLocaleLowerCase()
              ?.split("-")[0] === "all"
              ? ""
              : searchParams
                  .get("data-category")
                  ?.toLocaleLowerCase()
                  ?.split("-")[0] || "",
        }}
        count={data?.data?.count ?? 10}
        form={<JourneyForm refetch={groupRefetch} />}
      />
    </>
  );
};

export default index;
